import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import LoadingContent from '../../component/loading/LoadingContent'
import styled from "styled-components";
import TableStations from './TableStations'
import Station from './Station'
import service from '../../service/Station'
import actions from "../../redux/actions";

const Section = styled.section`
    height: 100%;
    
    & > .container{ 
        height: 100%;
    }

`;

export default function Index(props) {

  const { stationId } = useParams()
  const [data, setData] = useState([])
  const [content, setContent] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(actions.master.setPath("/stations"))
    const init = async() =>{
      let data = await service.search()
      if (data) {
        setData(data)
        setContent(true)
      }
    }

    init()
   
  }, [dispatch])

  return (
    <Section className={"section-station" + (props.className ? props.className : "")}>
      <div className="container">
        {!content ? <LoadingContent />
          :
          <>
            <div className="page-title">
              <img src='/image/dashboard.png' alt="icon-dashboard"/>
              <span>ข้อมูลสถานี</span>
            </div>
            {!stationId ? (
              <TableStations data={data} />
            ) : (
              <Station stationId={stationId} />
            )
            }
          </>
        }
      </div>
    </Section>
  )
}
